const displayError = (res) => {
    if (res.data !== undefined && res.data !== null) {
        if (typeof res.data === 'string') {
            if (res.data === "token verification fail") {
                return "tokenExpired";
            } else if (res.data === "permission denied") {
                return "noPermission";
            }
            return res.data;
        } else {
            return JSON.stringify(res.data);
        }
    }

    return JSON.stringify(res);
}

export default {
    install(Vue, options) {
        Vue.prototype.$Fetcher = new (function () {
            const DataValid = Vue.prototype.$validate.DataValid;
            const devLog = Vue.prototype.$common.log;

            this.Login = async function (username, password) {
                try {
                    const payload = {
                        username,
                        password
                    };
                    const data = await Vue.prototype.$XHR.api('staff_login', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: Login', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: Login');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: Login', res);
                    return Promise.reject(displayError(res));
                }
            }


            /**
             * 會員管理
             */
            this.GetUsers = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'user_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetUsers');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetUsers');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUsers', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetUserById = async function (id) {
                const payload = {
                    id,
                    data_type: 'user_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetUserById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetUserById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewUser = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_user', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewUser');
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: NewUser');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewUser', res);
                    switch (res.data) {
                        case 'phone exist':
                            return Promise.reject('message.phoneExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.UpdateUser = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    await Vue.prototype.$XHR.api('edit_user', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateUser');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateUser', res);
                    switch (res.data) {
                        case 'phone exist':
                            return Promise.reject('message.phoneExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }



            this.GetUserCompanies = async function (user_id) {
                const payload = {
                    user_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_user_company', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetUserCompanies', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetUserCompanies');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserCompanies', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetCompanies = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'company_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetCompanies');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetCompanies');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCompanies', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetCompanyById = async function (id) {
                const payload = {
                    id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_company', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetCompanyById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetCompanyById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCompanyById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetCompaniesLyIdList = async function (id_list) {
                const payload = {
                    data_type: 'company_data',
                    id_list
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetCompaniesLyIdList');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetCompaniesLyIdList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAddons', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewCompany = async function (user_id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    user_id,
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_company', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewCompany');
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: NewCompany');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewCompany', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateCompany = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('update_company', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateCompany');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateCompany');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCompany', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.DeleteCompany = async function (id) {
                const payload = {
                    id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('delete_company', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: DeleteCompany');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: DeleteCompany');
                        return Promise.reject('message.errorOccur');
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteCompany', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetCompanyDocument = async function (company_id) {
                const payload = {
                    id: company_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_company_document', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetCompanyDocument', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetCompanyDocument');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCompanyDocument', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetCompanyDocumentsByType = async function (company_id, type, filters = {}) {
                let payload = {
                    data_type: 'document_data',
                    ...filters
                };

                payload.filters = [
                    { key: 'status', value: 'active' },
                    { key: 'company_id', value: company_id },
                    { key: 'type', value: type },
                ];

                if (filters.filters) {
                    payload.filters = [
                        ...filters.filters,
                        ...payload.filters
                    ];
                }

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetCompanyDocumentsByType');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetCompanyDocumentsByType');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCompanyDocumentsByType', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewCompanyDocument = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_document', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewCompanyDocument');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: NewCompanyDocument');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewCompanyDocument', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateCompanyDocument = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('edit_document', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateCompanyDocument');
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCompanyDocument', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.AddMemberToCompany = async function (id, upload) {
                try {
                    const company = await Vue.prototype.$XHR.api('get_company', { id });
                    let member_list = company.member_list;
                    if (!member_list) {
                        member_list = [];
                    }
                    member_list.push(upload);

                    const data = await Vue.prototype.$XHR.api('update_company', {
                        id,
                        member_list: member_list
                    });
                    if (DataValid(data) && DataValid(data.member_list)) {
                        devLog('----------> XHR [SUCCESS]: AddMemberToCompany');
                        return Promise.resolve(data.member_list);
                    } else {
                        devLog('----------> XHR [NULL]: AddMemberToCompany');
                        return Promise.reject(null);
                    }

                } catch (res) {
                    devLog('----------> XHR [FAIL]: AddMemberToCompany', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateCompanyMember = async function (company_id, index, upload) {
                try {
                    const company = await Vue.prototype.$XHR.api('get_company', { id: company_id });
                    let member_list = company.member_list;
                    if (member_list[index]) {
                        for (let key in upload) {
                            if (member_list[index][key] !== undefined) {
                                member_list[index][key] = upload[key];
                            }
                        }

                        const data = await Vue.prototype.$XHR.api('update_company', {
                            id: company_id,
                            member_list: member_list
                        });

                        if (DataValid(data)) {
                            devLog('----------> XHR [SUCCESS]: UpdateCompanyMember');
                            return Promise.resolve(data.member_list);
                        } else {
                            devLog('----------> XHR [NULL]: UpdateCompanyMember');
                            return Promise.reject(null);
                        }
                    } else {
                        devLog('----------> XHR [NULL]: UpdateCompanyMember');
                        return Promise.reject('message.memberNotFound');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCompanyMember', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.RemoveCompanyMember = async function (company_id, index) {
                try {
                    const company = await Vue.prototype.$XHR.api('get_company', { id: company_id });
                    let member_list = company.member_list;
                    if (member_list[index]) {
                        member_list.splice(index, 1);

                        const data = await Vue.prototype.$XHR.api('update_company', {
                            id: company_id,
                            member_list: member_list
                        });

                        if (DataValid(data)) {
                            devLog('----------> XHR [SUCCESS]: RemoveCompanyMember');
                            return Promise.resolve(data.member_list);
                        } else {
                            devLog('----------> XHR [NULL]: RemoveCompanyMember');
                            return Promise.reject(null);
                        }
                    } else {
                        devLog('----------> XHR [NULL]: RemoveCompanyMember');
                        return Promise.reject('message.memberNotFound');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RemoveCompanyMember', res);
                    return Promise.reject(displayError(res));
                }
            }







            /**
            * 增值服務管理
            */
            this.GetAddons = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'addon_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetAddons');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetAddons');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAddons', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetAddonById = async function (id) {
                const payload = {
                    id,
                    data_type: 'addon_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetAddonById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetAddonById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAddonById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewAddon = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_addon', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewAddon');
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: NewAddon');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewAddon', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateAddon = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    await Vue.prototype.$XHR.api('edit_addon', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateAddon');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateAddon', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.DeleteAddon = async function (id) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    active: false
                };

                try {
                    await Vue.prototype.$XHR.api('edit_addon', payload);
                    devLog('----------> XHR [SUCCESS]: DeleteAddon');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteAddon', res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
            * 計劃管理
            */
            this.GetPlans = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'plan_data',
                    sort_dir: 'asc',
                    order_by: 'id',
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetPlans');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetPlans');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPlans', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetPlanById = async function (id) {
                const payload = {
                    id,
                    data_type: 'plan_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPlanById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetPlanById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPlanById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewPlan = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_plan', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewPlan');
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: NewPlan');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewPlan', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdatePlan = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    await Vue.prototype.$XHR.api('edit_plan', payload);
                    devLog('----------> XHR [SUCCESS]: UpdatePlan');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdatePlan', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetSecretaryPlans = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'plan_data',
                    filters: [
                        { key: 'type', value: 'secretary' },
                        { key: 'status', value: 'active' }
                    ],
                    sort_dir: 'asc',
                    order_by: 'price',
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetSecretaryPlans');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetSecretaryPlans');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSecretaryPlans', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetVrOfficePlans = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'plan_data',
                    filters: [
                        { key: 'type', value: 'virtual_office' },
                        { key: 'status', value: 'active' }
                    ],
                    sort_dir: 'asc',
                    order_by: 'price',
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetVrOfficePlans');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetVrOfficePlans');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetVrOfficePlans', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetPlanByIdList = async function (id_list) {
                const payload = {
                    id_list,
                    data_type: 'plan_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPlanByIdList', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetPlanByIdList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPlanByIdList', res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
            * Blog
            */
            this.GetBlogs = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'blog_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetBlogs');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetBlogs');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBlogs', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetBlogById = async function (id) {
                const payload = {
                    id,
                    data_type: 'blog_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetBlogById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetBlogById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBlogById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewBlog = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_blog', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewBlog');
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: NewBlog');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewBlog', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateBlog = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    await Vue.prototype.$XHR.api('edit_blog', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateBlog');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateBlog', res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
            * Faq
            */
            this.GetFaqs = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'faq_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetFaqs');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetFaqs');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetFaqs', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetFaqById = async function (id) {
                const payload = {
                    id,
                    data_type: 'faq_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetFaqById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetFaqById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetFaqById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewFaq = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_faq', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewFaq');
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: NewFaq');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewFaq', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateFaq = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    await Vue.prototype.$XHR.api('edit_faq', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateFaq');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateFaq', res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
            * Faq
            */
            this.GetEnquiries = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'contact_us_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetEnquiries');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetEnquiries');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetEnquiries', res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
            * 信件／包裹
            */
            this.GetLetters = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'package_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetLetters');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetLetters');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLetters', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetLetterById = async function (id) {
                const payload = {
                    id,
                    data_type: 'package_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetLetterById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetLetterById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLetterById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewLetter = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_package', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewLetter');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: NewLetter');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewLetter', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateLetter = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('edit_package', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateLetter');
                        return Promise.resolve(true);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateLetter');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateLetter', res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
            * 訂單管理
            */
            this.GetOrders = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'order_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetOrders');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrders');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrders', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetOrderById = async function (id) {
                const payload = {
                    id,
                    data_type: 'order_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetOrderById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrderById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewOrder = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('new_order', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewOrder');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: NewOrder');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewOrder', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateOrder = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('edit_order', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOrder', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: UpdateOrder');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOrder', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetPaymentById = async function (id) {
                const payload = {
                    id,
                    data_type: 'payment_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPaymentById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetPaymentById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPaymentById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetPaymentByIdList = async function (id_list) {
                const payload = {
                    id_list,
                    data_type: 'payment_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPaymentByIdList', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetPaymentByIdList');
                        return Promise.reject([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPaymentByIdList', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateOrderPayment = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    await Vue.prototype.$XHR.api('update_payment', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateOrderPayment');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOrderPayment', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetOrdersAndBills = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'order_and_bill'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetOrdersAndBills');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetOrdersAndBills');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrdersAndBills', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.NewServiceSubmit = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('new_request_service', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewServiceSubmit');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: NewServiceSubmit');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewServiceSubmit', res);
                    return Promise.reject(displayError(res));
                }
            }






            /**
            * 新增訂單
            */
            this.NewBill = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_bill', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewBill');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: NewBill');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewBill', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetBillById = async function (id) {
                const payload = {
                    id,
                    data_type: 'bill_data'
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetBillById', data);
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetBillById');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBillById', res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateBill = async function (id, upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    id,
                    ...upload,
                };

                try {
                    await Vue.prototype.$XHR.api('edit_bill', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateBill');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateBill', res);
                    return Promise.reject(displayError(res));
                }
            }




            /**
            * 客戶申請新服務 (唔洗付款的order)
            */
            this.GetAppliedServices = async function (filters = {}) {
                const payload = {
                    ...filters,
                    data_type: 'request_service_data'
                };

                if (payload.filters && payload.filters.length < 1) {
                    delete payload.filters;
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_data_by_data_type', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetAppliedServices');
                        devLog(data)
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: GetAppliedServices');
                        return Promise.reject(null);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAppliedServices', res);
                    return Promise.reject(displayError(res));
                }
            }





            this.NewAlert = async function (upload) {
                if (upload["active"]) {
                    delete upload["active"];
                }

                const payload = {
                    ...upload,
                };

                try {
                    const data = await Vue.prototype.$XHR.api('add_alert', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewAlert');
                        return Promise.resolve(data);
                    } else {
                        devLog('----------> XHR [NULL]: NewAlert');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewAlert', res);
                    return Promise.reject(displayError(res));
                }
            }
        });
    },
}